<div style="padding:24px 32px 0">
    <app-logic-port-base-info [item]="data"></app-logic-port-base-info>
    <app-base-performace-chart [id]="data.actionParams" [performance]="[22,21,370]" type="LIF_PORT_TYPE" *ngIf="!FeatureConfig.IsHidePms"></app-base-performace-chart>
</div>
